import React, { useEffect, useState } from 'react';
import { getAgentPerformance } from '../../../lib/api/agents';
import { agentPerformance } from '../../../mocks/agentDetail';
import PerformanceChart from '../components/PerformanceChart';

function PerformanceTab({ agent }) {
  const [performance, setPerformance] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    getAgentPerformance(agent.id)
      .then((data) => {
        if (!cancelled) setPerformance(data);
      })
      .catch(() => {
        // No backend yet — mocks are the interim API contract.
        if (!cancelled) setPerformance(agentPerformance(agent.id));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [agent.id]);

  if (isLoading) {
    return <p className="tab-empty">Loading performance…</p>;
  }

  return <PerformanceChart performance={performance} />;
}

export default PerformanceTab;
